const scaleToHeight = (intrinsicDimensions, targetHeight) => {
  const { width, height } = intrinsicDimensions;
  const scale = targetHeight / height;
  return {
    height: targetHeight,
    width: Math.round(width * scale)
  };
};

const scaleToWidth = (intrinsicDimensions, targetWidth) => {
  const { width, height } = intrinsicDimensions;
  const scale = targetWidth / width;
  return {
    width: targetWidth,
    height: Math.round(height * scale)
  };
};

/**
 * Traverses the provided HTML AST node and populates the width and height properties
 * of image nodes with the dimensions provided in the imageDimensions mapping.
 * @param {*} node An HTML AST node
 * @param {*} imageDimensions A mapping of image src to their dimensions
 * @returns An updated HTML AST node with image dimensions populated
 */
const populateImageDimensions = (node, imageDimensions = {}) => {
  const updated = { ...node };
  const { tagName, properties, children } = node;
  if (tagName === 'img') {
    const dimensions = imageDimensions[properties.src];
    if (dimensions) {
      if (properties.width && !properties.height) {
        const scaledDimensions = scaleToWidth(dimensions, properties.width);
        updated.properties.width = scaledDimensions.width;
        updated.properties.height = scaledDimensions.height;
      } else if (properties.height && !properties.width) {
        const scaledDimensions = scaleToHeight(dimensions, properties.height);
        updated.properties.width = scaledDimensions.width;
        updated.properties.height = scaledDimensions.height;
      } else if (!properties.width && !properties.height) {
        updated.properties.width = dimensions.width;
        updated.properties.height = dimensions.height;
      }
    }
  }
  if (children?.length) {
    updated.children = children.map(child => populateImageDimensions(child, imageDimensions));
  }

  return updated;
};

module.exports = populateImageDimensions;
